/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import PageHeader from "../../../components/PageHeader";
import useForm from "../../../hooks/useForm";
// tab page
import BasicInfo from "./BasicInfo";
import AdditionalInfo from "./AdditionalInfo";
import HeadBranch from "./HeadBranch/HeadBranchList";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { modifyCompaniesDetail } from "../../../apis/companies/company-infos";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { isEmpty, isEqual } from "lodash";
import { restoreComNum } from "../../../utils/validator/comNum";
import systemAlert from "../../../utils/systemAlert";
import { setProfile } from "../../../store/profile/actions";
import { permissionCheck } from "../../../utils/permission";
import { clipboardCopy } from "../../../utils/browser";
import ThirdPartyMesseger from "./ThirdPartyMesseger";

const ManagerCompanyInfo = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('basic-info');
  const [basicInfoMode, setBasicInfoMode] = useState("detail");
  const { company, permissions } = useSelector((store) => ({
    company: store.Profile.company,
    permissions: store.Profile.permissions
  }),
    shallowEqual
  );

  const [targetPermission, setTargetPermission] = useState(null);

  useEffect(() => {
    if (!isEmpty(permissions)) {
      const permission = permissions.find(p => p.code === 'COMPANY_MANAGEMENT');
      setTargetPermission(permission);
      if (isEmpty(permission)) {
        permissionCheck(history, "COMPANY_MANAGEMENT");
      }
    }
  }, [permissions]);

  const _setActiveTab = (value) => {
    history.push(`/manager/company-info?tab=${value}`);
  };

  const tabList = [
    { label: "기본정보", action: _setActiveTab, value: 'basic-info' },
    { label: "추가정보", action: _setActiveTab, value: 'addtional-info' },
    { label: "본/지점관리", action: _setActiveTab, value: 'head-branch' },
    { label: "외부 알람 관리", action: _setActiveTab, value: 'third-party-messeger' },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);

  useEffect(() => {
    if (company && activeTab === 'basic-info') {
      const data = {
        ...company,
        type: String(company.type),
        incomType: String(company.incomType),
        sep: String(company.sep),
      };

      setOriginForm({
        ...data,
        comNum: restoreComNum(data.comNum)
      });
      setForm(data);
    }
  }, [company, activeTab]);

  const validate = ({
    name,
    ceoName,
    comNum,
    sep,
    rgeNum,
    incomType,
  }) => {
    let errors = {};

    if (!name) errors.name = "회사명은 필수입니다.";
    if (!ceoName) errors.ceoName = "대표자명은 필수입니다.";
    if (!comNum) errors.comNum = "사업자등록번호은 필수입니다.";
    if (!sep) errors.sep = "사업형태는 필수입니다.";
    if (sep === "0" && !rgeNum) errors.rgeNum = "법인 등록번호는 필수입니다.";
    if (!incomType) errors.incomType = "과세 유형은 필수입니다.";

    return errors;
  };

  const _submit = (form) => {
    if (originForm.comNum === form.comNum) {
      delete form.comNum;
    }


    systemAlert('회사 정보를 수정하시겠습니까?', {
      buttons: [
        {
          color: 'text',
          label: '취소'
        },
        {
          label: '확인',
          onClick: () => {
            modifyCompaniesDetail(company.idx, form)
              .then(() => {
                setBasicInfoMode("detail");
                dispatch(setProfile());
              })
              .catch((err) => {
                console.error(err.response);
              });
          }
        }
      ]
    });
  };

  const {
    form,
    setForm,
    originForm,
    setOriginForm,
    errors,
    handleOnChange,
    handleSubmit,
    setValidateFields
  } = useForm(
    {
      name: "",
      ceoName: "",
      comNum: "",
      sep: "",
      rgeNum: "",
      incomType: "",
      sectNum: "",
      openDate: "",
      zipCode: "",
      address: "",
      addressDetail: "",
      bsnSect: "",
      bsnType: "",
      bsnCode: "",
      phone: "",
      fax: "",
      taxEmail: "",
      taxName: "",
      taxCode: "",
      taxAccount: "",
    },
    _submit,
    validate
  );

  const findHeaderButton = (activeTab) => {
    let buttons = [{
      label: '회사초대 URL 복사',
      color: "text",
      action: () => {
        clipboardCopy(`https://web.wecake.io/sign-up?comNum=${company.comNum}`, '회사초대 URL이 복사되었습니다.');
      }
    }];
    switch (activeTab) {
      case "basic-info":
        if (basicInfoMode === "detail") {
          buttons.push({
            label: "수정하기",
            color: "line",
            action: () => {
              setBasicInfoMode("modify");
            },
          });
        } else {
          buttons.push({
            label: "취소",
            color: "gray-line",
            action: () => {
              setForm(originForm);
              setBasicInfoMode("detail");
            },
          });
          buttons.push({
            label: "변경 저장",
            action: handleSubmit,
            disabled: isEqual(originForm, form),
          });
        }
        break;
      default:
        break;
    }
    return buttons;
  };

  const headerButtons = findHeaderButton(activeTab);

  return (
    !isEmpty(targetPermission) && (
      <div className="page-content">
        <PageHeader
          title={"회사 정보 관리"}
          activeTab={activeTab}
          tabList={tabList}
          buttons={targetPermission.level > 1 ? headerButtons : []}
          handleSubmit={handleSubmit}
        />
        {activeTab === 'basic-info' && (
          <BasicInfo
            mode={basicInfoMode}
            form={form}
            setForm={setForm}
            handleOnChange={handleOnChange}
            errors={errors}
            setValidateFields={setValidateFields}
            permission={targetPermission}
          />
        )}
        {activeTab === "addtional-info" && <AdditionalInfo permission={targetPermission} />}
        {activeTab === "head-branch" && <HeadBranch permission={targetPermission} />}
        {activeTab === "third-party-messeger" && <ThirdPartyMesseger permission={targetPermission} />}
      </div>
    ));
};

export default ManagerCompanyInfo;
